import React, { Component } from "react";
import { getValue } from "../utils/models";
import { Row, Col } from "antd";
import AutoInput from "../containers/AutoInput";
import withValues from "../hocs/withValues";

class VehicleCreate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showContent: false,
      customer: null
    };
  }

  componentWillMount() {
    setTimeout(() => {
      this.setState({ showContent: true });
    }, 300);
  }

  componentDidUpdate(prevProps) {
    if (this.props.values !== prevProps.values) {
      this.setState({
        customer: getValue(this.props.values, "customer")
      });
    }
  }

  render() {
    return (
      <Row gutter={10}>
        <Col span={24}>
          <AutoInput
            form={this.props.form}
            model={"vehicle"}
            attribute={"economicNumber"}
          />
        </Col>
        <Col span={12}>
          <AutoInput
            form={this.props.form}
            model={"vehicle"}
            attribute={"make"}
          />
        </Col>
        <Col span={12}>
          <AutoInput
            form={this.props.form}
            model={"vehicle"}
            attribute={"model"}
          />
        </Col>
        <Col span={12}>
          <AutoInput
            form={this.props.form}
            model={"vehicle"}
            attribute={"year"}
          />
        </Col>
        <Col span={12}>
          <AutoInput
            form={this.props.form}
            model={"vehicle"}
            attribute={"purchasedAt"}
          />
        </Col>
        <Col span={12}>
          <AutoInput
            form={this.props.form}
            model={"vehicle"}
            attribute={"color"}
          />
        </Col>
        <Col span={12}>
          <AutoInput
            form={this.props.form}
            model={"vehicle"}
            attribute={"vin"}
          />
        </Col>
        <Col span={12}>
          <AutoInput
            form={this.props.form}
            model={"vehicle"}
            attribute={"plateMx"}
          />
        </Col>
        <Col span={12}>
          <AutoInput
            form={this.props.form}
            model={"vehicle"}
            attribute={"plateUsa"}
          />
        </Col>
        <Col span={12}>
          <AutoInput
            form={this.props.form}
            model={"vehicle"}
            attribute={"scac"}
          />
        </Col>
        <Col span={12}>
          <AutoInput
            form={this.props.form}
            model={"vehicle"}
            attribute={"caat"}
          />
        </Col>
        <Col span={12}>
          <AutoInput
            form={this.props.form}
            model={"vehicle"}
            attribute={"insurancePolicy"}
          />
        </Col>
        <Col span={12}>
          <AutoInput
            form={this.props.form}
            model={"vehicle"}
            attribute={"grossWeight"}
          />
        </Col>
        <Col span={24}>
          <AutoInput
            form={this.props.form}
            model={"vehicle"}
            attribute={"supplier"}
          />
        </Col>
        <Col span={12}>
          <AutoInput
            form={this.props.form}
            model={"vehicle"}
            attribute={"type"}
          />
        </Col>
        <Col span={12}>
          <AutoInput
            form={this.props.form}
            model={"vehicle"}
            attribute={"fuel"}
          />
        </Col>
        <Col span={24}>
          <AutoInput
            form={this.props.form}
            model={"vehicle"}
            attribute={"gpsSerialNumber"}
          />
        </Col>
      </Row>
    );
  }
}

export default withValues(VehicleCreate);



// WEBPACK FOOTER //
// ./src/forms/VehicleCreate.js